if (!customElements.get('beard-oil-landing')) {
  customElements.define(
    'beard-oil-landing',
    class BeardOilLanding extends HTMLElement {
      connectedCallback() {
        this.variantSelect = this.querySelector('[data-bo-variant-select]');
        this.variantData = this.readVariantData();
        this.variantTitle = [...this.querySelectorAll('[data-bo-variant-title]')];
        this.variantImage = [...this.querySelectorAll('[data-bo-variant-image]')];
        this.price = [...this.querySelectorAll('[data-bo-price]')];
        this.availability = [...this.querySelectorAll('[data-bo-availability]')];
        this.productLinks = [...this.querySelectorAll('[data-bo-product-link]')];
        this.scentCards = [...this.querySelectorAll('[data-bo-scent-card]')];
        this.submitButtons = [...this.querySelectorAll('[data-bo-submit]')];
        this.error = this.querySelector('[data-bo-error]');
        this.liveStatus = this.querySelector('[data-bo-live-status]');

        if (!this.variantSelect || !this.variantData.length) return;

        this.variantSelect.addEventListener('change', () => this.renderSelectedVariant());
        this.scentCards.forEach((card) => {
          card.addEventListener('click', () => this.selectScentCard(card));
        });
        this.submitButtons.forEach((button) => {
          button.addEventListener('click', () => this.addSelectedVariant());
        });

        this.renderSelectedVariant(false);
      }

      readVariantData() {
        const node = this.querySelector('[data-bo-variants]');
        if (!node) return [];

        try {
          return JSON.parse(node.textContent);
        } catch (error) {
          console.error('Could not read Arabian Beard Oil variant data.', error);
          return [];
        }
      }

      get selectedVariant() {
        return this.variantData.find(
          (variant) => String(variant.id) === String(this.variantSelect.value),
        );
      }

      renderSelectedVariant(announce = true) {
        const variant = this.selectedVariant;
        if (!variant) return;

        this.variantTitle.forEach((node) => {
          node.textContent = variant.displayTitle || variant.title;
        });
        this.price.forEach((node) => {
          node.innerHTML = variant.price;
        });
        this.variantImage.forEach((image) => {
          if (!variant.image) return;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = variant.image;
          image.alt = variant.imageAlt || variant.displayTitle || variant.title;
        });

        const productUrl = `${this.dataset.productUrl}?variant=${variant.id}`;
        this.productLinks.forEach((link) => link.setAttribute('href', productUrl));

        const available = Boolean(variant.available);
        this.availability.forEach((node) => {
          node.textContent = available
            ? this.dataset.availableLabel
            : this.dataset.soldOutLabel;
          node.dataset.available = String(available);
        });

        this.submitButtons.forEach((button) => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
          button.textContent = available
            ? `${this.dataset.buttonLabel} · ${variant.displayTitle || variant.title}`
            : this.dataset.soldOutLabel;
        });

        this.scentCards.forEach((card) => {
          const active = String(card.dataset.variantId) === String(variant.id);
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', String(active));
        });

        if (announce && this.liveStatus) {
          this.liveStatus.textContent = `${this.dataset.selectedLabel}: ${
            variant.displayTitle || variant.title
          }. ${available ? this.dataset.availableLabel : this.dataset.soldOutLabel}.`;
        }

        this.clearError();
      }

      selectScentCard(card) {
        if (!card || card.disabled || !card.dataset.variantId) return;
        this.variantSelect.value = card.dataset.variantId;
        this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      async addSelectedVariant() {
        const variant = this.selectedVariant;
        if (!variant || !variant.available) return;

        this.setLoading(true);
        this.clearError();
        const root = window.Shopify?.routes?.root || '/';

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: Number(variant.id), quantity: 1 }],
            }),
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || this.dataset.errorLabel);
          }

          window.location.assign(this.dataset.cartUrl || `${root}cart`);
        } catch (error) {
          this.showError(error.message || this.dataset.errorLabel);
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        const variant = this.selectedVariant;
        this.submitButtons.forEach((button) => {
          button.disabled = isLoading || !variant?.available;
          button.setAttribute('aria-busy', String(isLoading));
          button.textContent = isLoading
            ? this.dataset.loadingLabel
            : `${this.dataset.buttonLabel} · ${variant?.displayTitle || variant?.title || ''}`;
        });
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      clearError() {
        if (!this.error) return;
        this.error.textContent = '';
        this.error.hidden = true;
      }
    },
  );
}
